import { TextSelectorInput } from '@archipro-design/aria';

import { useState } from 'react';

interface SelectorValue {
    key: number;
    header: string;
}

const FilterDateDropdown = ({
    items,
    value,
    className,
    placeholder,
    onChange,
    defaultValue,
    disabled = false,
    searchQuery,
    onSearchChange,
}: {
    items: SelectorValue[];
    value?: string | null;
    defaultValue: number | null;
    placeholder: string;
    onChange: (item: number | undefined) => void;
    className?: string;
    disabled?: boolean;
    searchQuery?: string;
    onSearchChange: (data: string) => void;
}) => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <TextSelectorInput
                className={className}
                input={{
                    placeholder,
                    disabled,
                }}
                showChevronIcon={true}
                divider={{
                    color: 'primary',
                    size: 2,
                }}
                dropdown={{
                    disabled: false,
                    showChevronIcon: true,
                    open,
                    onClick: () => !disabled && setOpen(true),
                    onOpenChange: (_, data) =>
                        data.open !== undefined && setOpen(data.open),
                    toLowerCase: '2020',
                    searchQuery,
                    items,
                    value: value === null ? '' : value,
                    defaultSearchQuery: defaultValue
                        ? defaultValue.toString()
                        : '',
                    onChange: (_, data) => {
                        const newValue =
                            data.value === null
                                ? undefined
                                : (data.value as SelectorValue).key;
                        onChange(newValue);
                    },
                    onSearchQueryChange: (_, data) => {
                        onSearchChange(data.searchQuery ?? '');
                    },
                    search: (items, searchText) => {
                        return items.filter((i) =>
                            (i as SelectorValue).header
                                .toLowerCase()
                                .includes(searchText.toLowerCase()),
                        );
                    },
                }}
            />
        </>
    );
};

export default FilterDateDropdown;
